import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  sectionHighlightsBadge: {
    id: 'course-authoring.course-outline.section.badge.section-highlights',
    defaultMessage: 'Section highlights',
  },
  subsectionPickerModalTitle: {
    id: 'course-authoring.course-outline.section.subsection-modal.title',
    defaultMessage: 'Select subsection',
    description: 'Subsection modal picker title text in outline',
  },
});

export default messages;
